import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  public message = "";
  public isOpen = false;

  constructor(
    public modalSvc: ModalService,
    public dataSvc: DataService,
    public translate: TranslateService
  ) { 

    this.modalSvc.confirmModalSource$.subscribe((obj: any) => { 
        if(obj.action && obj.action === "open") {
            this.isOpen = true;
            this.message = obj.message;
        }
    });
    
    if(dataSvc != null && dataSvc !== undefined){
      var exisitingLangauge = localStorage.getItem("userslanguage");
      if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
        this.dataSvc.changeLangauge(exisitingLangauge);
      }
      else{
        this.translate.setDefaultLang("en");
        this.translate.use("en");
      }
    }
  }

  ngOnInit() {
  }

  closeModal(result: string) {
    this.isOpen = false;
    this.modalSvc.confirmModalSubject.next({ action: "close", result });
  }
}
